import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type ButtonGroup from './button-group.vue'

export const buttonGroupProps = buildProps({})

export type ButtonGroupProps = ExtractPropTypes<typeof buttonGroupProps>
export type ButtonGroupInstance = InstanceType<typeof ButtonGroup>
